import SegmentedControl from './SegmentedControl';
import type { IconComponent } from '@/components/icons';

export type ViewModeToggleOption<TValue extends string = string> = {
    value: TValue;
    label: string;
    icon: IconComponent;
    id?: string;
    disabled?: boolean;
};

interface ViewModeToggleProps<TValue extends string = string> {
    options: ViewModeToggleOption<TValue>[];
    value: TValue;
    onValueChange: (value: TValue) => void;
    ariaLabel: string;
    id?: string;
    className?: string;
}

export default function ViewModeToggle<TValue extends string = string>({
    options,
    value,
    onValueChange,
    ariaLabel,
    id,
    className,
}: ViewModeToggleProps<TValue>) {
    return (
        <SegmentedControl
            id={id}
            options={options.map((option) => {
                const Icon = option.icon;

                return {
                    ...option,
                    label: (
                        <span className="inline-flex size-4 items-center justify-center leading-none">
                            <Icon className="size-4" aria-hidden="true" />
                            <span className="sr-only">{option.label}</span>
                        </span>
                    ),
                };
            })}
            value={value}
            onValueChange={(nextValue) => onValueChange(nextValue as TValue)}
            variant="tabs"
            ariaLabel={ariaLabel}
            className={className}
            buttonClassName="h-9 w-10 px-0"
        />
    );
}
